import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// ─── Icons ────────────────────────────────────────────────────────────────────
const Icon = ({ d, size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    {Array.isArray(d) ? d.map((p, i) => <path key={i} d={p} />) : <path d={d} />}
  </svg>
);

const NAV_ITEMS = [
  {
    label: 'Main',
    items: [
      { path: '/dashboard',      label: 'Dashboard',          permission: 'dashboard',     icon: 'M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z' },
    ],
  },
  {
    label: 'Management',
    items: [
      { path: '/users',          label: 'User Management',    permission: 'users.view',    icon: ['M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2','M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z','M23 21v-2a4 4 0 0 0-3-3.87','M16 3.13a4 4 0 0 1 0 7.75'] },
      { path: '/battles',        label: 'Battles',            permission: 'battles',       icon: ['M14.5 10c-.83 0-1.5-.67-1.5-1.5v-5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5z','M20.5 10H19V8.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z','M9.5 14c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5S8 21.33 8 20.5v-5c0-.83.67-1.5 1.5-1.5z','M3.5 14H5v1.5c0 .83-.67 1.5-1.5 1.5S2 16.33 2 15.5 2.67 14 3.5 14z','M14 14.5c0-.83.67-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-5c-.83 0-1.5-.67-1.5-1.5z','M15.5 19H14v1.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z','M10 9.5C10 8.67 9.33 8 8.5 8h-5C2.67 8 2 8.67 2 9.5S2.67 11 3.5 11h5c.83 0 1.5-.67 1.5-1.5z','M8.5 5H10V3.5C10 2.67 9.33 2 8.5 2S7 2.67 7 3.5 7.67 5 8.5 5z'] },
      { path: '/walk-sessions',  label: 'Walk Sessions',      permission: 'battles',       icon: ['M13 2L3 14h9l-1 8 10-12h-9l1-8z'] },
      { path: '/challenges',     label: 'Challenges',         permission: 'battles',       icon: ['M8.21 13.89L7 23l5-3 5 3-1.21-9.12','M15 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0z','M21 20c0-3.87-4.03-7-9-7s-9 3.13-9 7'] },
      { path: '/rewards',        label: 'Rewards',            permission: 'battles',       icon: ['M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z'] },
      { path: '/leaderboard',    label: 'Leaderboard',        permission: 'dashboard',     icon: ['M8 6l4-4 4 4','M12 2v10.5','M20 21H4','M20 17v4','M16 13v8','M12 15v6','M8 17v4','M4 19v2'] },
      { path: '/admins',         label: 'Admin Management',   permission: 'admins',        icon: ['M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2','M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z','M16 11l2 2 4-4'] },
      { path: '/roles',          label: 'Role Management',    permission: 'roles.view',    icon: ['M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z'] },
    ],
  },
  {
    label: 'Content & Data',
    items: [
      { path: '/content',        label: 'Content (CMS)',      permission: 'content',       icon: ['M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z','M14 2v6h6','M16 13H8','M16 17H8','M10 9H8'] },
      { path: '/notifications',  label: 'Notifications',      permission: 'notifications', icon: ['M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9','M13.73 21a2 2 0 0 1-3.46 0'] },
      { path: '/referrals',      label: 'Referrals',          permission: 'users.view',    icon: ['M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71','M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71'] },
      { path: '/reports',        label: 'Reports',            permission: 'reports',       icon: ['M18 20V10','M12 20V4','M6 20v-6'] },
    ],
  },
  {
    label: 'Finance',
    items: [
      { path: '/withdrawals',   label: 'Withdrawals',        permission: 'reports',       icon: ['M12 2v20','M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6'] },
      { path: '/payments',      label: 'Payment Gateways',   permission: 'reports',       icon: ['M21 4H3a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z','M1 10h22'] },
      { path: '/transactions',  label: 'Transactions',       permission: 'reports',       icon: ['M12 1v22','M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6'] },
    ],
  },
  {
    label: 'System',
    items: [
      { path: '/app-config',     label: 'App Config',         permission: 'settings',      icon: ['M12 20h9','M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z'] },
      { path: '/cron-jobs',      label: 'Cron Jobs',          permission: 'settings',      icon: ['M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z','M12 6v6l4 2'] },
      { path: '/activity',       label: 'Activity Logs',      permission: 'activity_logs', icon: ['M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z','M12 18v-6','M9 15l3 3 3-3'] },
      { path: '/settings',       label: 'Settings',           permission: 'settings',      icon: ['M12 22c1.1 0 2-.9 2-2H10c0 1.1.9 2 2 2z','M12 2a7 7 0 0 0-7 7c0 2.39.93 4.57 2.46 6.19L8 17h8l.54-1.81A9.93 9.93 0 0 0 19 9a7 7 0 0 0-7-7z'] },
      { path: '/profile',        label: 'My Profile',         permission: null,            icon: ['M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2','M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z'] },
    ],
  },
];

const Sidebar = ({ collapsed, mobileOpen, onCloseMobile }) => {
  const { user, hasPermission, logout } = useAuth();
  const location = useLocation();

  const initials = user?.name?.split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase() || 'U';

  return (
    <>
      {/* Mobile overlay */}
      {mobileOpen && (
        <div style={styles.overlay} onClick={onCloseMobile} />
      )}

      <aside style={{
        ...styles.sidebar,
        width: collapsed ? 'var(--sidebar-collapsed)' : 'var(--sidebar-width)',
        transform: mobileOpen ? 'translateX(0)' : undefined,
      }}>
        {/* Logo */}
        <div style={styles.logoArea}>
          <div style={styles.logoIcon}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5">
              <path d="M12 2L2 7l10 5 10-5-10-5z"/>
              <path d="M2 17l10 5 10-5"/>
              <path d="M2 12l10 5 10-5"/>
            </svg>
          </div>
          {!collapsed && <span style={styles.logoText}>WalkBattle</span>}
        </div>

        {/* User info */}
        {!collapsed && (
          <div style={styles.userCard}>
            <div style={styles.userAvatar}>{initials}</div>
            <div style={styles.userInfo}>
              <div style={styles.userName}>{user?.name}</div>
              <div style={styles.userRole}>{user?.adminRole?.replace('_', ' ')}</div>
            </div>
          </div>
        )}

        {/* Navigation */}
        <nav style={styles.nav}>
          {NAV_ITEMS.map(group => {
            const visibleItems = group.items.filter(item =>
              item.permission === null || hasPermission(item.permission)
            );
            if (visibleItems.length === 0) return null;

            return (
              <div key={group.label} style={styles.navGroup}>
                {!collapsed && <span style={styles.groupLabel}>{group.label}</span>}

                {visibleItems.map(item => (
                  <NavLink
                    key={item.path}
                    to={item.path}
                    style={({ isActive }) => ({
                      ...styles.navItem,
                      ...(isActive ? styles.navItemActive : {}),
                      justifyContent: collapsed ? 'center' : 'flex-start',
                    })}
                    onClick={() => { if (window.innerWidth < 768) onCloseMobile(); }}
                    title={collapsed ? item.label : ''}
                  >
                    <span style={styles.navIcon}>
                      <Icon d={item.icon} />
                    </span>
                    {!collapsed && <span style={styles.navLabel}>{item.label}</span>}
                    {!collapsed && location.pathname === item.path && (
                      <span style={styles.activeDot} />
                    )}
                  </NavLink>
                ))}
              </div>
            );
          })}
        </nav>

        {/* Logout */}
        <div style={styles.bottomArea}>
          <button
            style={{
              ...styles.logoutBtn,
              justifyContent: collapsed ? 'center' : 'flex-start',
            }}
            onClick={logout}
            title={collapsed ? 'Logout' : ''}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
              <polyline points="16 17 21 12 16 7"/>
              <line x1="21" y1="12" x2="9" y2="12"/>
            </svg>
            {!collapsed && <span>Logout</span>}
          </button>
        </div>
      </aside>
    </>
  );
};

const styles = {
  overlay: {
    position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)',
    zIndex: 99, backdropFilter: 'blur(2px)',
  },
  sidebar: {
    position: 'fixed', top: 0, left: 0, height: '100vh',
    background: 'var(--bg-secondary)',
    borderRight: '1px solid var(--border-color)',
    display: 'flex', flexDirection: 'column',
    zIndex: 100,
    transition: 'width 0.3s ease, transform 0.3s ease',
    overflowX: 'hidden',
    overflowY: 'auto',
  },
  logoArea: {
    display: 'flex', alignItems: 'center', gap: '12px',
    padding: '20px 18px', borderBottom: '1px solid var(--border-color)',
    flexShrink: 0, minHeight: '64px',
  },
  logoIcon: {
    width: '36px', height: '36px', flexShrink: 0,
    borderRadius: '10px',
    background: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    boxShadow: '0 2px 10px rgba(99,102,241,0.4)',
  },
  logoText: { fontSize: '1.1rem', fontWeight: '800', color: 'var(--text-primary)', whiteSpace: 'nowrap' },
  userCard: {
    display: 'flex', alignItems: 'center', gap: '10px',
    padding: '14px 18px', borderBottom: '1px solid var(--border-color)',
    flexShrink: 0,
  },
  userAvatar: {
    width: '36px', height: '36px', borderRadius: '50%',
    background: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
    color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontWeight: '600', fontSize: '0.8rem', flexShrink: 0,
  },
  userInfo: { overflow: 'hidden' },
  userName: { fontSize: '0.875rem', fontWeight: '600', color: 'var(--text-primary)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' },
  userRole: { fontSize: '0.72rem', color: 'var(--accent-secondary)', whiteSpace: 'nowrap' },
  nav: { flex: 1, padding: '12px 0', overflowY: 'auto' },
  navGroup: { marginBottom: '4px' },
  groupLabel: {
    display: 'block', padding: '8px 18px 4px',
    fontSize: '0.68rem', fontWeight: '600', textTransform: 'uppercase',
    letterSpacing: '0.08em', color: 'var(--text-muted)',
  },
  navItem: {
    display: 'flex', alignItems: 'center', gap: '10px',
    padding: '9px 18px',
    color: 'var(--text-secondary)',
    borderRadius: '0', transition: 'all 0.2s',
    fontSize: '0.875rem',
    textDecoration: 'none',
    position: 'relative',
  },
  navItemActive: {
    color: 'var(--accent-secondary)',
    background: 'rgba(99,102,241,0.1)',
    borderRight: '3px solid var(--accent-primary)',
  },
  navIcon: { flexShrink: 0, display: 'flex', alignItems: 'center' },
  navLabel: { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' },
  activeDot: {
    marginLeft: 'auto', width: '6px', height: '6px',
    borderRadius: '50%', background: 'var(--accent-primary)',
    flexShrink: 0,
  },
  bottomArea: {
    padding: '12px',
    borderTop: '1px solid var(--border-color)',
    flexShrink: 0,
  },
  logoutBtn: {
    display: 'flex', alignItems: 'center', gap: '10px',
    width: '100%', padding: '10px 12px',
    background: 'none', border: 'none', cursor: 'pointer',
    color: 'var(--text-secondary)', borderRadius: '8px',
    fontSize: '0.875rem', transition: 'all 0.2s',
  },
};

export default Sidebar;
